import customHeaderProcessor from './customHeaderProcessor'
import readOnlyProcessor from './readOnlyProcessor'
import columnCssClassProcessor from './columnCssClassProcessor'
import duplicitiesProcessor from './duplicitiesProcessor'

/**
 * Main class for execution of particular processors.
 */
export default class {
    constructor(tableOptions) {
        this.table = tableOptions;
        this.processors = [
            customHeaderProcessor,
            readOnlyProcessor,
            columnCssClassProcessor,
            duplicitiesProcessor
        ];

    }

    process(row, col, cell, prop, cellProperties) {
        if (!this.table) {
            return;
        }

        for (const processor of this.processors) {
            processor(row, col, cell, prop, this.table, cellProperties);
        }
    }
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/cellprocessors/cellProcessor.js